import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { LOCALE_ID, NgModule, provideZonelessChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LightboxComponent } from './modules/shared/lightbox/lightbox.component';
import { ToastContainerComponent } from './modules/shared/toast-container/toast-container.component';

@NgModule({
  declarations: [
    AppComponent,
    LightboxComponent,
    ToastContainerComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    FontAwesomeModule,
    NgbModule
  ],
  providers: [
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideZonelessChangeDetection(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'en'
    }),
    { provide: 'REMOVE_STYLES_ON_COMPONENT_DESTROY', useValue: false },
    { provide: LOCALE_ID, useValue: 'fr' }
  ]
})
export class AppModule {}
